<script setup>
import WebsitePriceInformation from "@/components/website/WebsitePriceInformation.vue";
import WebsitePricingTiers from "@/components/website/WebsitePricingTiers.vue";
import {ref} from "vue";

const showPricingTiers = ref(false);

defineProps({
  product: {
    type: Object,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  alternateHasDiscount: {
    type: Boolean,
    required: true,
  },
  inclusions: {
    type: Array,
    required: true,
  },
});

</script>

<template>
  <WebsitePriceInformation
    v-if="!showPricingTiers"
    :product="product"
    :description="description"
    :alternate-has-discount="alternateHasDiscount"
    :inclusions="inclusions"
    @show-tiers="showPricingTiers = true"
  />
  <WebsitePricingTiers
    v-else
    :product="product"
    @back="showPricingTiers = false"
  />
</template>

